import React from 'react';
import { colors, typography } from '../../../styles/theme';
import { FILTER_ACCENT, FILTER_ACCENT_CONTRAST } from './FilterPanel.styles';

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  minHeight: '36px',
};

const labelStyle = {
  flex: 1,
  fontSize: typography.fontSize.sm,
  fontFamily: typography.fontFamily.primary,
  color: colors.textPanelDescription,
  lineHeight: typography.lineHeight.normal,
};

const boxStyle = ({ checked = false, disabled = false } = {}) => ({
  width: '18px',
  height: '18px',
  borderRadius: '4px',
  border: `1.5px solid ${checked ? FILTER_ACCENT : colors.border}`,
  backgroundColor: checked ? FILTER_ACCENT : 'transparent',
  cursor: disabled ? 'not-allowed' : 'pointer',
  flexShrink: 0,
  opacity: disabled ? 0.6 : 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const checkmarkStyle = {
  width: '9px',
  height: '5px',
  borderLeft: `2px solid ${FILTER_ACCENT_CONTRAST}`,
  borderBottom: `2px solid ${FILTER_ACCENT_CONTRAST}`,
  transform: 'rotate(-45deg) translateY(-1px)',
};

/**
 * Booleano inline en fila (sin acordeón).
 * @param {string} [title] tooltip nativo; se usa para explicar el estado deshabilitado
 */
function FilterInlineCheckbox({
  label,
  checked,
  onChange,
  disabled = false,
  title,
}) {
  return (
    <label
      style={{ ...rowStyle, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.6 : 1 }}
      title={title}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked ? 1 : null)}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
      />
      <span style={boxStyle({ checked, disabled })} aria-hidden>
        {checked && <span style={checkmarkStyle} />}
      </span>
      <span style={labelStyle}>{label}</span>
    </label>
  );
}

export default FilterInlineCheckbox;
